function berechneVersandzeit1bis3() {
    return berechneVersandzeit(1, 3);
}

function berechneVersandzeit2bis7() {
    return berechneVersandzeit(2, 7);
}

function berechneVersandzeit4bis15() {
    return berechneVersandzeit(4, 15);
}

function berechneVersandzeit3month() {
    return berechneVersandzeit(30, 35);
}

function berechneVersandzeit(tageMin, tageMax) {
    let heute = new Date();
    
    // Wenn es nach 12:00 Uhr ist, auf den nächsten Tag setzen
    if (heute.getHours() >= 12) {
        heute.setDate(heute.getDate() + 1);
    }
    
    let versandMin, versandMax;
    
    function addWerktage(startdatum, tage) {
        let datum = new Date(startdatum);
        while (tage > 0) {
            datum.setDate(datum.getDate() + 1);
            let tag = datum.getDay();
            if (tag !== 5 && tag !== 6 && !istFeiertag(datum)) { // Freitag, Samstag und Feiertage überspringen
                tage--;
            }
        }
        return datum;
    }
    
    function istFeiertag(datum) {
        const feiertage = [
            '01-01', // Neujahr
            '05-01', // Tag der Arbeit
            '10-03', // Tag der Deutschen Einheit
            '12-25', // 1. Weihnachtstag
            '12-26'  // 2. Weihnachtstag
        ];
        let datumString = datum.toISOString().slice(5, 10);
        return feiertage.includes(datumString);
    }
    
    versandMin = addWerktage(heute, tageMin);
    versandMax = addWerktage(heute, tageMax);
    
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    return `
    Voraussichtliche Lieferung: ${versandMin.toLocaleDateString('de-DE', options)} - ${versandMax.toLocaleDateString('de-DE', options)}
`;
}

document.addEventListener("DOMContentLoaded", function() {
    let versandElement = document.getElementById("versandzeit-anzeige");
    if (!versandElement) return;

    // Den Tag für die Versandzeit holen
    let versandzeitTag = versandElement.getAttribute("data-tags");

    // Versandzeit berechnen basierend auf dem Tag
    let versandText = "";

    if (versandzeitTag.includes("1-3;;")) {
        versandText = berechneVersandzeit1bis3();
    } else if (versandzeitTag.includes("2-7;;")) {
        versandText = berechneVersandzeit2bis7();
    } else if (versandzeitTag.includes("4-15;;")) {
        versandText = berechneVersandzeit4bis15();
    } else if (versandzeitTag.includes("3month;;")) {
        versandText = berechneVersandzeit3month();
    }

    // Wenn Versandzeit gefunden, zeige diese an
    if (versandText) {
        versandElement.innerText = versandText;
    } else {
        versandElement.innerText = "Versandzeit nicht verfügbar";
    }
});


document.addEventListener("DOMContentLoaded", function() {
    // Hier wird der Barcode ausgelesen
    let barcodeTag = document.querySelector('#barcode').textContent.trim(); // Beispiel: Barcode in einem Element mit id="barcode"
    
    let versandText = "";

    // Berechnung basierend auf Barcode Tag
    if (barcodeTag.includes("1-3;;")) {
        versandText = berechneVersandzeit1bis3();
    } else if (barcodeTag.includes("2-7;;")) {
        versandText = berechneVersandzeit2bis7();
    } else if (barcodeTag.includes("4-15;;")) {
        versandText = berechneVersandzeit4bis15();
    } else if (barcodeTag.includes("3month;;")) {
        versandText = berechneVersandzeit3month();
    }

    // Versandzeit anzeigen
    let versandElement = document.getElementById("versandzeit-anzeige");
    if (versandElement) {
        if (versandText) {
            versandElement.innerText = versandText;
        } else {
            versandElement.innerText = "Versandzeit nicht verfügbar";
        }
    }
});

// Die gleichen Versandzeit-Funktionen wie oben
function berechneVersandzeit1bis3() {
    return berechneVersandzeit(1, 3);
}

function berechneVersandzeit2bis7() {
    return berechneVersandzeit(2, 7);
}

function berechneVersandzeit4bis15() {
    return berechneVersandzeit(4, 15);
}

function berechneVersandzeit3month() {
    return berechneVersandzeit(30, 35);
}

function berechneVersandzeit(tageMin, tageMax) {
    let heute = new Date();
    
    // Wenn es nach 12:00 Uhr ist, auf den nächsten Tag setzen
    if (heute.getHours() >= 12) {
        heute.setDate(heute.getDate() + 1);
    }
    
    let versandMin, versandMax;
    
    function addWerktage(startdatum, tage) {
        let datum = new Date(startdatum);
        while (tage > 0) {
            datum.setDate(datum.getDate() + 1);
            let tag = datum.getDay();
            if (tag !== 5 && tag !== 6 && !istFeiertag(datum)) { // Freitag, Samstag und Feiertage überspringen
                tage--;
            }
        }
        return datum;
    }
    
    function istFeiertag(datum) {
        const feiertage = [
            '01-01', // Neujahr
            '05-01', // Tag der Arbeit
            '10-03', // Tag der Deutschen Einheit
            '12-25', // 1. Weihnachtstag
            '12-26'  // 2. Weihnachtstag
        ];
        let datumString = datum.toISOString().slice(5, 10);
        return feiertage.includes(datumString);
    }
    
    versandMin = addWerktage(heute, tageMin);
    versandMax = addWerktage(heute, tageMax);
    
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    return `Voraussichtliche Lieferung: ${versandMin.toLocaleDateString('de-DE', options)} - ${versandMax.toLocaleDateString('de-DE', options)}`;
}
